import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../services/environment.service';

@Injectable()
export class SystemInterceptor implements HttpInterceptor {

  constructor(
    private environmentService: EnvironmentService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // this.environmentService.system.subscribe(response => {
    //   request = request.clone({
    //     setHeaders: {
    //       SystemInformation: JSON.stringify(response)
    //     }
    //   });
    // });
    return next.handle(request);
  }
}
